
// Evaluaciones v1 deprecadas: reemplazadas por las rutas de router/new_evaluation.js.
// Equivalencias v1 -> v2:
//   EvaluationView / SpecificationTableView -> NewEvaluationView   (/evaluations/v2/form/:evaluation_id/)
//   AnswerView                              -> EvaluateeView       (/evaluations/v2/answer/:evaluation_id/)
//   NeedsGradingView                        -> EvaluatorView       (/evaluations/v2/instrument-correction/:evaluation_id/)
//   FullGradingCenterView                   -> NewFullGradingView  (/evaluations/full-grading/v2/:section_id/)
export default [
    // {
    //     path: '/instrument/',
    //     name: 'InstrumentView',
    //     component: () =>
    //         import("@/components/evaluations/tmp/InstrumentView"),
    // },
    // {
    //     path: '/evaluation/form/:evaluation_id/',
    //     name: 'EvaluationView',
    //     component: () =>
    //         import("@/components/evaluations/EvaluationView"),
    // },
    // {
    //     path: '/evaluation/form/:evaluation_id/:question_test_id/',
    //     name: 'SpecificationTableView',
    //     component: () =>
    //         import("@/components/evaluations/SpecificationTable/SpecificationTableView"),
    // },
    // {
    //     path: '/evaluation/needs-grading/:section_id/',
    //     name: 'NeedsGradingView',
    //     component: () =>
    //         import("@/components/evaluations/NeedsGrading/NeedsGradingView"),
    // },
    // {
    //     path: '/evaluation/full-grading/:section_id/',
    //     name: 'FullGradingCenterView',
    //     component: () =>
    //         import("@/components/evaluations/NeedsGrading/FullGradingCenterView"),
    // },
    // {
    //     path: '/answer/:evaluation_id/',
    //     name: 'AnswerView',
    //     component: () =>
    //         import("@/components/evaluations/AnswerView"),
    // },
];
